module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/introduction01_sp-1f15be1488023db90a6e6391de47bace.png";